export default __webpack_public_path__ + "static/affiliate-program-Software-2@mob2x-f3d9a10dad8c67a50633e1c3ed258b23.webp";